import { connect } from 'react-redux';
import ZoneContainer from './ZoneContainer';

// style methods
import {
  styleMethods
} from 'dataviz/config/map';
import { hexToRgb } from 'util/color';

// actions
import {
  updateSeedApplicationProduct,
  updateProductApplicationProperty
} from 'scripts';
import {
  blurProductApplicationInput,
  selectZone
} from 'current/uiwidgets';
import { setActiveZoneId } from 'current';

// constants
import {
  applicationTypes,
  scriptTypes
} from 'constants/scripts';

// selectors
import {
  canChooseSeedProduct,
  getActiveSeedProducts,
  getSelectedZoneIds,
  isZoneEditingDisabled,
  usingLiquidIsChecked,
  getNitrogenApplicationRateType
} from 'current/selectors';
import {
  getSeedApplicationsForZone
} from 'scripts/zones/planting-selectors';
import {
  getFertilizerApplicationsForZone,
  hasFertilizerApplicationsForZones
} from 'scripts/zones/fertility-selectors';
import {
  getZoneValidationResult
} from 'validations/selectors';
import { getProductValidationValues } from 'user/selectors';
import { getNominalWeightByScript } from 'crops/selectors';
import { getApplicationTypeForScriptType } from '../scripts/selectors';
import { getApplicationsForZoneByType } from '../scripts/zones/selectors';
import { 
  transformNitrogenRateToFertilizer
} from 'products/fertility-selectors';


export default connect(
  (state, ownProps) => {
    const { index, script, scriptTypeIsNitrogen, scriptType, zone, zoneRef } = ownProps;
    const { zones } = script;
    const { area, zoneId, isCheckStrip } = zone.meta;
    const zoneProductivity = zone?.geoJson?.properties?.relativeProductivity?.v;
    const isDeadZone = zone?.geoJson?.properties?.isDeadZone;

    const { fertilizerRate, seedRate } = styleMethods;
    const styleMethod = scriptType === scriptTypes.PLANTING ? seedRate : fertilizerRate;
    const productValidationValues = getProductValidationValues(state);
    const applicationType = getApplicationTypeForScriptType(scriptType);
    const fertilizerApplications = applicationType === applicationTypes.APPLICATION
      ? getApplicationsForZoneByType({ zone, applicationType })
      : getFertilizerApplicationsForZone(zone);
      
    /**
     * TODO: refactor CFVWEB-8862
     * As a new zone is created, It comes with initial data that is not complete to support an APPLICATION script.
     * To avoid issues with this new zone when it must be colored, we are hardcoding some params
     */
    let zoneIdentifierColor;
    try {
      zoneIdentifierColor = hexToRgb(styleMethod(script, productValidationValues, zone).fillColor);
    }
    catch(error) {
      zoneIdentifierColor = {r: 248, g: 248, b: 248};
    }
    return {
      activeSeedProducts: getActiveSeedProducts(state),
      canChooseSeedProduct: canChooseSeedProduct(state),
      cropNominalWeight: getNominalWeightByScript(state, script),
      isCheckStrip,
      isEditingDisabled: isZoneEditingDisabled(state),
      fertilizerApplications,
      scriptTypeIsNitrogen,
      scriptType,
      seedApplications: getSeedApplicationsForZone(zone),
      selectedZoneIds: getSelectedZoneIds(state),
      showLiquidApplication: hasFertilizerApplicationsForZones(zones) || usingLiquidIsChecked(state),
      validationResult: getZoneValidationResult(state, zoneId),
      zoneArea: area,
      zoneDisplayNumber: index + 1,
      zoneId,
      zoneIdentifierColor,
      zoneRef: zoneRef,
      zoneProductivity,
      isDeadZone,
      transformNitrogenRateToFertilizer: 
        nitrogenRate => transformNitrogenRateToFertilizer(state, script, nitrogenRate),
      nitrogenApplicationRateType: getNitrogenApplicationRateType(state)
    };
  },
  (dispatch, ownProps) => {
    const { activeZoneId, script: { id: scriptId }, zone } = ownProps;
    const { zoneId } = zone.meta;

    return {
      onBlurProductApplicationInput: () => dispatch(blurProductApplicationInput()),
      onChangeProductApplicationInput: ({ value, property }) => {
        dispatch(updateProductApplicationProperty({ property, scriptId, value, zoneId }));
      },
      onClickProductApplicationInput: (e) => {
        e.stopPropagation();
        if (activeZoneId !== zoneId) {
          dispatch(setActiveZoneId({ zoneId }));
        }
      },
      onSelectSeedProduct: ({ productId }) => dispatch(updateSeedApplicationProduct({ productId, scriptId, zoneId })),
      onClickZone: () => dispatch(selectZone({ mapWasClickedOnZoneSelect: false, zoneId })),
    };
  }
)(ZoneContainer);
